import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

export const wizardContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
  borderRadius: 4,
  boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)',
  border: '1px solid transparent',
  margin: '24px 43px 27px 43px',
};

const getStyles = (_, { palette }) => ({
  defaultLayout: {
    height: '100%',
    width: '100%',
    '& .react-block-ui-none, .react-block-ui': {
      height: '100%',
      width: '100%',
    },
    '& .error': {
      color: '#A80000',
    },
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
    width: '100%',
  },
  stepListContainer: {
    minWidth: '228px',
    overflow: 'hidden auto',
  },
  wizardContent: wizardContentStyle,
  stepContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
    background: palette.neutralLighterAlt,
    padding: '24px 32px',
    '&>div': {
      marginBottom: 48,
    },
    '& .pmax-targeting-step-shell, & .budget-step': {
      paddingTop: 20,
    },
  },
  footerContainer: {
    borderTop: `1px solid ${palette.neutralQuaternaryAlt}`,
    padding: '16px 32px',
  },
  '@global': {
    '.fui-Toaster': {
      bottom: '100px !important',
      left: '60px !important',
    },
  },
});

export const SDKWizardTemplate = ({ items }) => {
  const {
    Blocker = React.Fragment,
    LoadingShimmer,
    StepList,
    StepContainer,
    Footer,
  } = items;
  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classNames('sdk-wizard-layout', classes.defaultLayout)}>
      <Blocker>
        <div className={classNames('main-container', classes.mainContainer)}>
          <div className={classNames('wizard-content', 'step-content-and-footer', classes.wizardContent)}>
            <div className={classNames('step-list-container', classes.stepListContainer)}>
              <StepList />
            </div>
            <div className={classNames('step-content-container', classes.stepContentContainer)}>
              <LoadingShimmer />
              <StepContainer />
            </div>
            <div className={classNames('footer-container', classes.footerContainer)}>
              <Footer />
            </div>
          </div>
        </div>
      </Blocker>
    </div>
  );
};

SDKWizardTemplate.propTypes = {
  items: PropTypes.shape({
    Blocker: PropTypes.func,
    LoadingShimmer: PropTypes.func,
    StepList: PropTypes.func,
    StepContainer: PropTypes.func.isRequired,
    Footer: PropTypes.func,
    CancelDialog: PropTypes.func,
    StepHeader: PropTypes.func,
  }).isRequired,
  config: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
};
